import React, { Component } from "react";
import { View, Image, TouchableOpacity, ScrollView, Dimensions, KeyboardAvoidingView } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, customerLocationStyles, profileStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import Button from "../components/Button";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { myProfileRequest, citiesRequest, areaRequest, editProfileRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import DialogList from "../components/DialogList";
import DialogMessage from "../components/DialogMessage";
import { getError } from "../utils/utils";
import TextInput from "../components/TextInput/TextInput";
import { wp, hp } from "../utils/responsive";
const regexnonenglishdigit = /[a-z]|[A-Z]|[0-9]|[۱۲۳۴۵۶۷۸۹۰]/g;

export default class ProfileScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            first_name: '',
            last_name: '',
            phone: '',
            koche: '',
            vahed: '',
            pelak: '',
            address: '',
            national_code: '',
            mobile: '',
            email: '',
            waiting: true,
            cityModal: false,
            areaModal: false,
            showMessage: false,
            messageTitle: '',
            messageContent: '',
            messageSucces: false,
            cities: [],
            areas: [],
            selectedCity: null,
            selectedArea: null,
            selectedBimeh: { id: 0 },
            bimeCode: '',
            bimeDate: '',
            lat: '',
            lng: '',
            gender: 0,
        }
        this.inputs = {};
    }
    focusTheField = (prev, next) => {
        this.inputs[prev].blur()

        this.inputs[next].focus();
    }
    render() {
        return (
            <ScrollView contentContainerStyle={{ width: wp(100) }} enableOnAndroid={true} keyboardShouldPersistTaps='handled'>
                <View style={appStyles.flex1}>
                    <View style={appStyles.toolbarWraper}>
                        <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                        <TextView style={appStyles.toolbarTitle}>اطلاعات کاربری</TextView>
                        <TouchableOpacity onPress={() => {
                            this.props.navigation.goBack()
                        }}>
                            <Image source={icons['back']} style={appStyles.backIcon} />
                        </TouchableOpacity>
                    </View>

                    <LinearGradient colors={[blueDarkColor, blueLightColor]} style={profileStyles.wraper}>
                        <View>
                            <TextInput
                                placeholder='نام و نام خانوداگی'
                                mode='outlined'
                                wrapperStyle={{ width: wp(90) }}
                                ref={input => { this.inputs['fname'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('fname', 'lname') }}
                                onChangeText={(text) => {
                                    this.setState({
                                        first_name: text.replace(regexnonenglishdigit, '')
                                    })
                                }}
                                value={this.state.first_name}
                            />
                            {/* <TextInput
                        placeholder='نام خانوادگی'
                        mode='outlined'
                        ref={input => { this.inputs['lname'] = input }}
                        returnKeyType={'next'}
                        onSubmitEditing={() => { this.focusTheField('lname', 'email') }}
                        style={appStyles.outlineTextInput}
                        onChangeText={(text) => {
                            this.setState({
                                last_name: text
                            })
                        }}
                        value={this.state.last_name}
                    /> */}
                            <TextInput
                                placeholder='ایمیل'
                                mode='outlined'
                                ref={input => { this.inputs['email'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('email', 'phone') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        email: text
                                    })
                                }}
                                value={this.state.email}
                            />
                            <TextInput
                                placeholder='تلفن ثابت'
                                mode='outlined'
                                inputType='numeric'
                                ref={input => { this.inputs['phone'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('phone', 'koche') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        phone: text
                                    })
                                }}
                                value={this.state.phone}
                            />
                            <View style={[appStyles.row, { marginTop: 5,justifyContent:'space-around' }]}>
                                <TouchableOpacity style={profileStyles.textMidInput} onPress={() => {
                                    this.setState({
                                        areaModal: true
                                    })
                                }}>
                                    <TextView style={{ color: '#ffffffcc' }}>{this.state.selectedArea != null ? this.state.selectedArea.name : 'منطقه'}</TextView>
                                </TouchableOpacity>
                                <TouchableOpacity style={profileStyles.textMidInput} onPress={() => {
                                    this.setState({
                                        cityModal: true
                                    })
                                }}>
                                    <TextView style={{ color: '#ffffffcc' }}>{this.state.selectedCity != null ? this.state.selectedCity.name : 'شهر'}</TextView>
                                </TouchableOpacity>

                            </View>

                            <TextInput
                                placeholder='کوچه'
                                mode='outlined'
                                ref={input => { this.inputs['koche'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('koche', 'pelak') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        koche: text
                                    })
                                }}
                                value={this.state.koche}
                            />
                            <View style={appStyles.row}>
                                <TextInput
                                    placeholder='واحد'
                                    mode='outlined'
                                    inputType='numeric'
                                    ref={input => { this.inputs['vahed'] = input }}
                                    returnKeyType={'next'}
                                    onSubmitEditing={() => { this.focusTheField('vahed', 'address') }}
                                    wrapperStyle={{ width: wp(42) }}
                                    onChangeText={(text) => {
                                        this.setState({
                                            vahed: text
                                        })
                                    }}
                                    value={this.state.vahed}
                                />
                                <TextInput
                                    placeholder='پلاک'
                                    mode='outlined'
                                    inputType='numeric'
                                    ref={input => { this.inputs['pelak'] = input }}
                                    returnKeyType={'next'}
                                    onSubmitEditing={() => { this.focusTheField('pelak', 'vahed') }}
                                    wrapperStyle={{ width: wp(42) }}
                                    onChangeText={(text) => {
                                        this.setState({
                                            pelak: text
                                        })
                                    }}
                                    value={this.state.pelak}
                                />
                            </View>
                            <TextInput
                                placeholder='آدرس'
                                mode='outlined'
                                ref={input => { this.inputs['address'] = input }}
                                returnKeyType={'next'}
                                onSubmitEditing={() => { this.focusTheField('address', 'codemeli') }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        address: text
                                    })
                                }}
                                value={this.state.address}
                            />
                            <TextInput
                                placeholder='کد ملی'
                                mode='outlined'
                                returnKeyType={'done'}
                                maxLength={10}
                                inputType='numeric'
                                ref={input => { this.inputs['codemeli'] = input }}
                                onSubmitEditing={() => {

                                }}
                                wrapperStyle={{ width: wp(90) }}
                                onChangeText={(text) => {
                                    this.setState({
                                        national_code: text
                                    })
                                }}
                                value={this.state.national_code}
                            />
                        </View>
                        <View style={[appStyles.bottomViewSimple, appStyles.center]}>
                            <Button
                                style={customerLocationStyles.button}
                                text='ثبت و ویرایش اطلاعات'
                                textStyle={customerLocationStyles.buttonText}
                                onPress={() => {
                                    if (this.state.selectedCity != null) {
                                        this.setState({
                                            waiting: true
                                        })
                                        editProfileRequest(this.state.email, this.state.first_name, this.state.last_name,
                                            this.state.phone, this.state.selectedCity.id, this.state.selectedArea != null ? this.state.selectedArea.number : '', this.state.koche,
                                            this.state.vahed, this.state.pelak, this.state.address, this.state.gender, this.state.selectedBimeh.id,
                                            this.state.bimeCode, this.state.bimeDate, this.state.lat, this.state.lng, this.state.national_code, (isConnect, response) => {
                                                this.setState({
                                                    waiting: false
                                                })
                                                if (isConnect && response.isSuccess) {
                                                    this.setState({
                                                        showMessage: true,
                                                        messageContent: response.message,
                                                        messageSucces: true
                                                    })
                                                    // this.getData()
                                                } else {
                                                    this.setState({
                                                        showMessage: true,
                                                        messageSucces: false,
                                                        messageContent: getError(response)
                                                    })
                                                }
                                            })
                                    } else {
                                        this.setState({
                                            showMessage: true,
                                            messageSucces: false,
                                            messageContent: 'شهر و منطقه خود را انتخاب نمایید'
                                        })
                                    }

                                }}
                            />
                        </View>
                    </LinearGradient>

                    <DialogList
                        show={this.state.cityModal}
                        title='انتخاب شهر'
                        field='name'
                        data={this.state.cities}
                        onSelect={(item, index) => {
                            this.setState({
                                cityModal: false,
                                selectedCity: item,
                            })
                            areaRequest(item.id, (isConnect, response) => {
                                if (isConnect && response.isSuccess) {
                                    this.setState({
                                        areas: response.data
                                    })
                                }
                            })

                        }}
                        onCancel={() => {
                            this.setState({
                                cityModal: false
                            })
                        }} />
                    <DialogList
                        show={this.state.areaModal}
                        title='انتخاب منطقه'
                        field='name'
                        data={this.state.areas}
                        onSelect={(item, index) => {
                            this.setState({
                                areaModal: false,
                                selectedArea: item,
                            })

                        }}
                        onCancel={() => {
                            this.setState({
                                areaModal: false
                            })
                        }} />
                    <DialogMessage
                        show={this.state.showMessage}
                        title={this.state.messageTitle}
                        message={this.state.messageContent}
                        onClose={() => {
                            this.setState({
                                showMessage: false
                            })
                            if (this.state.messageSucces) {
                                this.props.navigation.goBack()
                            }
                        }} />
                    <Waiting waiting={this.state.waiting} />

                </View>
            </ScrollView>)
    }

    componentWillMount() {
        this.getData()
        citiesRequest((isConnect, response) => {
            if (isConnect && response.isSuccess) {
                this.setState({
                    cities: response.data
                })
            }
        })
    }
    getData() {
        this.setState({
            waiting: true
        })
        myProfileRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                var user = response.data;
                var selectedArea = null;
                var selectedCity = null;
                if (user.areanumber != null) {
                    selectedArea = { id: user.areanumber, name: user.areaname, number: user.areanumber }
                }
                if (user.cityid != null) {
                    selectedCity = { name: user.cityname, id: user.cityid }
                }
                this.setState({
                    first_name: user.flname,
                    last_name: user.lname,
                    email: user.email,
                    phone: user.phone,
                    koche: user.koche,
                    vahed: user.vahed,
                    pelak: user.pelak,
                    address: user.address,
                    selectedArea: selectedArea,
                    selectedCity: selectedCity,
                    national_code: user.ncode
                })
            }
        })
    }
}
